export default __webpack_public_path__ + "static/antalyaspor-logo-8aa1c08ed7f3711c2d55fd032a115292.png";